module.exports = __webpack_public_path__ + "img/icon-plus.8451582a.svg";